export default {
  1: 'google',
  2: 'bing',
  3: 'yahoo',
  4: 'youtube'
}
